import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Lottie from "lottie-react";

// 👉 Put your lottie json in src/assets and import it
// Example: import confirmAnim from "../assets/lotties/confirm.json";
import confirmAnim from "../../lotties/check.json";

const CallsDialog = ({ open, data = [], onClose, onSubmit, loading }) => {
return (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 4,
        boxShadow: "0px 24px 64px rgba(0,0,0,0.18)",
      },
    }}
  >
    {/* Header */}
    <DialogTitle
      sx={{
        pb: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Typography fontWeight={700} fontSize={18}>
        Enquiries
        <Typography
          component="span"
          fontSize={13}
          color="text.secondary"
          sx={{ ml: 1 }}
        >
          ({data.length})
        </Typography>
      </Typography>

      <IconButton onClick={onClose}>
        <CloseRoundedIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent
      dividers
      sx={{
        py: 2,
        maxHeight: "70vh",
      }}
    >
      {data.length === 0 && (
        <Typography
          textAlign="center"
          color="text.secondary"
          sx={{ mt: 4 }}
        >
          No enquiries found
        </Typography>
      )}

      {data.map((item) => (
        <Box
          key={item.EnquiryID}
          sx={{
            mb: 1.5,
            p: 2,
            borderRadius: 3,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            transition: "all 0.2s ease",
            "&:hover": {
              boxShadow: 2,
              transform: "translateY(-1px)",
            },
          }}
        >
          {/* Top row */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
          >
            <Typography fontWeight={600} fontSize={14}>
              Enquiry #{item.EnquiryID}
            </Typography>

            <Typography fontSize={12} color="text.secondary">
              {item.cDt?.split(" ")[0] || ""}
            </Typography>
          </Box>

          {/* User Info */}
          <Box
            mt={1.2}
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            gap={0.5}
          >
            <Typography fontSize={14}>
              {item.UserName}
            </Typography>

            <Typography fontSize={13} color="text.secondary">
              {item.UserMobile}
            </Typography>
          </Box>
        </Box>
      ))}
    </DialogContent>

    {/* Footer */}
    <DialogActions sx={{ p: 2 }}>
      <Button
        onClick={onClose}
        fullWidth
        variant="outlined"
        sx={{
          borderRadius: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
);
};

export default CallsDialog;
